"use strict";

var _toConsumableArray = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventSenderReporter = void 0;

var event_sender_1 = require("@spotify-internal/event-sender");

var createSemanticMetricClient_1 = require("@spotify-internal/event-definitions/es5/events/createSemanticMetricClient");

var createSemanticMetricClientNonAuth_1 = require("@spotify-internal/event-definitions/es5/events/createSemanticMetricClientNonAuth");

var isomorphic_logger_1 = __importDefault(require("@spotify-internal/isomorphic-logger"));

var transport_1 = require("@spotify-internal/transport");

var constants_1 = require("../constants");

function getEventCreator(transport) {
  return function (metric) {
    return transport.isAuthenticated() ? createSemanticMetricClient_1.createSemanticMetricClient(metric) : createSemanticMetricClientNonAuth_1.createSemanticMetricClientNonAuth(metric);
  };
}

var EventSenderReporter =
/*#__PURE__*/
function () {
  function EventSenderReporter(eventSender, createEvent) {
    var environment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'browser';
    var transport = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, EventSenderReporter);

    this.eventSender = eventSender;
    this.createEvent = createEvent;
    this.environment = environment;
    this.transport = transport;
  }

  _createClass(EventSenderReporter, [{
    key: "send",
    value: function send(metrics) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, metric, clonedMetric, event;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 3;

                for (_iterator = metrics[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  metric = _step.value;
                  clonedMetric = Object.assign({}, metric);
                  clonedMetric.tags = Object.assign({}, clonedMetric.tags);

                  if (clonedMetric.tags.environment) {
                    isomorphic_logger_1.default.error('`tags.environment` must not be set. It is a reserved tag and will be overwritten.');
                  }

                  clonedMetric.tags.environment = this.environment;
                  event = this.createEvent(Object.assign({}, clonedMetric));
                  this.eventSender.send(event, Object.assign({
                    flush: false
                  }, !this.transport.isAuthenticated() && {
                    authorize: false
                  }));
                }

                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 11:
                _context.prev = 11;
                _context.prev = 12;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 14:
                _context.prev = 14;

                if (!_didIteratorError) {
                  _context.next = 17;
                  break;
                }

                throw _iteratorError;

              case 17:
                return _context.finish(14);

              case 18:
                return _context.finish(11);

              case 19:
                return _context.abrupt("return", this.eventSender.flush(this.transport.isAuthenticated()));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 7, 11, 19], [12,, 14, 18]]);
      }));
    }
  }], [{
    key: "create",
    value: function create(config) {
      var _this = this;

      var getToken = 'getToken' in config ? config.getToken : null;
      var ownerProvider = 'ownerProvider' in config ? config.ownerProvider : null;
      var context = config.context ? _toConsumableArray(config.context) : undefined;
      var environment = config.environment;
      var transport = transport_1.createBaseTransport({
        providers: {
          endpoints: function () {
            var xresolveProvider = transport_1.createXResolveProvider();
            return function (publicTransport) {
              return __awaiter(_this, void 0, void 0,
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee2() {
                var endpoints;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return xresolveProvider(publicTransport);

                      case 2:
                        endpoints = _context2.sent;
                        return _context2.abrupt("return", Object.assign(Object.assign({}, endpoints), config.internal && {
                          webgate: constants_1.INTERNAL_WEBGATE_URL
                        }));

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));
            };
          }(),
          token: function token() {
            return new Promise(function (resolve) {
              if (!getToken) {
                resolve('');
                return;
              }

              getToken(function (token, ttl) {
                if (typeof ttl !== 'undefined') {
                  resolve([token, ttl]);
                  return;
                }

                resolve(token);
              });
            });
          }
        }
      });

      if (getToken) {
        transport.on(transport_1.TransportEvent.CONNECTED, function () {
          transport.authenticate();
        });
        transport.on(transport_1.TransportEvent.AUTHENTICATED, function () {
          isomorphic_logger_1.default.debug('created authenticated browser transport');
        });
        transport.on(transport_1.TransportEvent.TOKEN_PROVIDER_ERROR, function () {
          isomorphic_logger_1.default.debug("the token provided is isn't working.");
        });
      }

      transport.connect();
      var eventSender = event_sender_1.createEventSender(Object.assign({
        transport: transport,
        context: context
      }, ownerProvider && {
        ownerProvider: ownerProvider
      }));
      var createEvent = getEventCreator(transport);
      return new EventSenderReporter(eventSender, createEvent, environment, transport);
    }
  }, {
    key: "createWithCustomTransport",
    value: function createWithCustomTransport(config) {
      var ownerProvider = 'ownerProvider' in config ? config.ownerProvider : null;
      var eventSender = event_sender_1.createEventSender(Object.assign({
        transport: config.transport
      }, ownerProvider && {
        ownerProvider: ownerProvider
      }));
      var createEvent = getEventCreator(config.transport);
      return new EventSenderReporter(eventSender, createEvent, config.environment, config.transport);
    }
  }]);

  return EventSenderReporter;
}();

exports.EventSenderReporter = EventSenderReporter;